import React, { Component } from 'react';
import * as Constants from './api/constants'

import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import AdminSettingsSVLink from './adminSettings.components/AdminSettingsSVLink'

export default class AdminSettings extends Component {
  constructor(props) {
    super(props);
    
  }

  componentDidMount() {
    this.load();
  }

  load = () => {
    this.setState({ loading: true });
  };

  render() {
    return (
      <Container sx={{ mt: 4, mb: 4 }}>
        <Grid item xs={12} md={12} lg={12}>
          <Paper sx={{
            p: 2, bgcolor: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.08)', borderRadius: 4
          }}>
            <AdminSettingsSVLink />
          </Paper>
        </Grid>
      </Container>
    );
  }
}